<ng-lottie [options]="options" class="lottie size-{{ size }}"></ng-lottie>
